import styled from 'styled-components';
import { ChevronDownSmall } from 'ui/icons/navigation/ChevronDownSmall';
import { Menu } from 'ui/menu/Menu';
import { PrimaryButton, GhostButton } from 'ui/button';
import { spacing } from 'ui/theme';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

const PAGE_ACTIONS_TEXT = {
  copyButton: 'Copy permissions from',
  menuId: 'copy-permissions-from',
  saveButton: 'Save role',
};

type Props = {
  onChange: (value: string) => void;
  onClick: () => void;
  options: any;
};

export const PageActions = ({ onChange, onClick, options }: Props) => {
  return (
    <Wrapper>
      <Menu id={PAGE_ACTIONS_TEXT.menuId} handleSelectionChange={onChange} options={options}>
        <GhostButton>
          <span>{PAGE_ACTIONS_TEXT.copyButton}&hellip;</span>
          <ChevronDownSmall />
        </GhostButton>
      </Menu>
      <PrimaryButton onClick={onClick}>
        <span>{PAGE_ACTIONS_TEXT.saveButton}</span>
      </PrimaryButton>
    </Wrapper>
  );
};
